import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
`;

export const LoadingContainer = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
`;

export const StyledPaper = styled.div<{
  $isLoading?: boolean;
  $withSpacing?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.primary.white};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: ${(props) => props.theme.radius['3px']};

  ${({ $isLoading }) =>
    !!$isLoading &&
    css`
      ${Content} {
        display: none;
      }

      ${LoadingContainer} {
        display: flex;
      }
    `}

  ${({ $withSpacing }) =>
    !!$withSpacing &&
    css`
      padding: ${(props: any) => props.theme.spacing['16px']};
    `}
`;
